import { render, staticRenderFns } from "./ForegroundAudio.vue?vue&type=template&id=5122adec&scoped=true&"
import script from "./ForegroundAudio.vue?vue&type=script&lang=js&"
export * from "./ForegroundAudio.vue?vue&type=script&lang=js&"
import style0 from "./ForegroundAudio.vue?vue&type=style&index=0&id=5122adec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5122adec",
  null
  
)

export default component.exports